<ngx-loading-bar [includeSpinner]="false" color="rgb(255,174,0)" height="6px" ref="http" *ngIf="isLoading$ | async"></ngx-loading-bar>
<div class="background-container">
    <div class="card-container">
        <form class="form-horizontal" [formGroup]="htmlForm" role="form" name="addEditItemForm" autocomplete="off">
            <div class="card card-register" *ngIf="!isFinished">
                <div class="card-header header-colors">
                    <h5 style="font-weight: bold;">Inscriere</h5>
                </div>
                <div class="card-body">
                    <aw-wizard #wizard [navBarLayout]="'large-filled-symbols'" class="custom-step-css" [disableNavigationBar]="true">
                        <aw-wizard-step stepTitle="Utilizator">
                            <ng-template awWizardStepSymbol><i class="step-symbol-icon uil uil-users-alt"></i></ng-template>
                            <div class="d-flex flex-column justify-content-between mt-2 h-100" *ngIf="!showValidation">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Prenume<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-user icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="Alexandru"
                                                        formControlName="firstName">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Nume<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-users-alt icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="Popescu"
                                                        formControlName="lastName">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Email<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-envelope icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="freya@gmail.com"
                                                        formControlName="email">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Telefon<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-phone icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="0740 000 000"
                                                        formControlName="phone">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center align-items-center mt-2" *ngIf="showValidation">
                                <div class="col-md-6 mb-2">
                                    <div class="form-group mt-3 mt-sm-0">
                                        <label>Cod verificare din SMS<span class="text-danger">*</span></label>
                                        <div class="input-container">
                                            <i class="uil uil-bars icon"></i>
                                            <input id="url" class="form-control input-field" aria-required="false"
                                                aria-invalid="false" type="text" placeholder="123456"
                                                formControlName="verificationCode">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </aw-wizard-step>

                        <aw-wizard-step stepTitle="Companie">
                            <ng-template awWizardStepSymbol><i class="step-symbol-icon uil uil-building"></i></ng-template>
                            <div class="d-flex flex-column justify-content-between mt-2 h-100" *ngIf="isUniqueCodeValidated === true">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group mt-3 mt-sm-0">
                                            <label>Nume Companie<span class="text-danger">*</span></label>
                                            <div class="input-container">
                                                <i class="uil uil-building icon"></i>
                                                <input id="url" class="form-control input-field" aria-required="false"
                                                    aria-invalid="false" type="text" placeholder="Freya S.R.L"
                                                    formControlName="name">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>CUI<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-bars icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="RO12345678"
                                                        formControlName="uniqueCode">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Oras<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-building icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="Bucuresti"
                                                        formControlName="city">
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="col-md-6">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Cod de indentificare<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-key-skeleton icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="J00/000/2013"
                                                        formControlName="identificationCode">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-2">
                                            <div class="form-group mt-3 mt-sm-0">
                                                <label>Adresa<span class="text-danger">*</span></label>
                                                <div class="input-container">
                                                    <i class="uil uil-map-marker icon"></i>
                                                    <input id="url" class="form-control input-field" aria-required="false"
                                                        aria-invalid="false" type="text" placeholder="Bulevardul Unirii Nr. 1"
                                                        formControlName="address">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center align-items-center mt-2" *ngIf="isUniqueCodeValidated === false">
                                <div class="col-md-6 mb-2">
                                    <div class="form-group mt-3 mt-sm-0">
                                        <label>CUI firma<span class="text-danger">*</span></label>
                                        <div class="input-container">
                                            <i class="uil uil-bars icon"></i>
                                            <input id="url" class="form-control input-field" aria-required="false"
                                                aria-invalid="false" type="text" placeholder="RO12345678"
                                                formControlName="uniqueCode">
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                        </aw-wizard-step>

                        <aw-wizard-step stepTitle="Optiuni">
                            <ng-template awWizardStepSymbol>
                                <i class="uil uil-cog"></i>
                            </ng-template>
                            <div class="row">
                                <!-- <div class="col-md-12 mb-2">
                                    <div class="form-group mt-3 mt-sm-0">
                                        <label>Tip instalare<span class="text-danger">*</span></label>
                                            <ng-select bindLabel="text" name="installationType" formControlName="installationType"
                                            [clearable]="true" [searchable]="true" [items]="listOfInstallationTypes"
                                            placeholder="Selecteaza tipul de program."></ng-select>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-12 mb-2">
                                    <div class="form-check form-switch form-group" style="margin-top: 10px;">
                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style="margin-right: 10px;" formControlName="hardwarePackage">
                                        <label class="form-check-label" for="flexSwitchCheckDefault" style=" margin-top: 5px;">Pachet Hardware<em class="fa fa-info-circle fa-fw text-default" placement="top" container="body"
                                            ngbTooltip="Achizitionarea dispozitivelor necesare prin Freya POS!"></em></label>
                                    </div>
                                </div> -->
                                <div class="col-md-12 mb-2">
                                    <div class="form-check form-switch form-group" style="margin-top: 10px;display: flex; align-items: center;">
                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style="margin-right: 10px;" formControlName="termsAndConditions">
                                        <label class="form-check-label" for="flexSwitchCheckDefault" style=" margin-top: 5px;">
                                            <span style="color: grey;font-weight: 100;"> Sunt de acord cu <a [routerLink]="['/termeni-si-conditii']" class="link" target="_blank">termenii si conditiile</a> FREYAPOS SRL și cu regulile expuse în <a [routerLink]="['/regulament-campanie']" class="link" target="_blank">regulamentul campaniei</a>.</span> 
                                        </label>
                                    </div>
                                </div>
                            </div>
    
    
                        </aw-wizard-step>
                    </aw-wizard>
                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-end" *ngIf="wizard.currentStepIndex === 0 && !showValidation">
                        <button class="btn btn-primary custom-secondary-button" [disabled]="checkUserPageValidity()" (click)="btnNextClick()">
                            <span style="margin-right: 7px;">Continua</span>
                            <i class="uil uil-message me-2"></i>
                        </button>
                    </div>
                    <div class="d-flex justify-content-between" *ngIf="wizard.currentStepIndex === 0 && showValidation">
                        <button class="btn btn-primary custom-primary-button" (click)="btnHideValidation()">
                            <i class="uil uil-corner-up-left-alt me-2"></i>
                            <span style="margin-right: 7px;">Inapoi</span>
                        </button>
                        <button class="btn btn-primary custom-secondary-button" (click)="validateSMSCode()">
                            <span style="margin-right: 7px;">Validare</span>
                            <i class="uil uil-check me-2"></i>
                        </button>
                    </div>
                    <div class="d-flex justify-content-between" *ngIf="wizard.currentStepIndex === 1 && !isUniqueCodeValidated">
                        <button class="btn btn-primary custom-primary-button" (click)="btnPreviousClick()">
                            <i class="uil uil-corner-up-left-alt me-2"></i>
                            <span style="margin-right: 7px;">Inapoi</span>
                        </button>
                        <button class="btn btn-primary custom-secondary-button" (click)="validateUniqueCode()">
                            <span style="margin-right: 7px;">Validare</span>
                            <i class="uil uil-check me-2"></i>
                        </button>
                    </div>
                    <div class="d-flex justify-content-between" *ngIf="wizard.currentStepIndex === 1 && isUniqueCodeValidated">
                        <button class="btn btn-primary custom-primary-button" (click)="btnHideCompanyDetails()">
                            <i class="uil uil-corner-up-left-alt me-2"></i>
                            <span style="margin-right: 7px;">Inapoi</span>
                        </button>
                        <button class="btn btn-primary custom-secondary-button" [disabled]="checkCompanyPageValidity()" (click)="btnNextClick()">
                            <span style="margin-right: 7px;">Continua</span>
                            <i class="uil uil-message me-2"></i>
                        </button>
                    </div>
                    <div class="d-flex justify-content-between" *ngIf="wizard.currentStepIndex === 2">
                        <button class="btn btn-primary custom-primary-button" (click)="btnPreviousClick()">
                            <i class="uil uil-corner-up-left-alt me-2"></i>
                            <span style="margin-right: 7px;">Inapoi</span>
                        </button>
                        <button [disabled]="this.htmlForm.value.termsAndConditions !== true" class="btn btn-primary custom-secondary-button" (click)="btnFinalizaClick()">
                            <span style="margin-right: 7px;">Finalizare</span>
                            <i class="uil uil-message me-2"></i>
                        </button>
                    </div>

                </div>
            </div>
        </form>


        <div class="card card-finished" *ngIf="isFinished">
            <div class="card-body">
                <div class="d-flex justify-content-center align-items-center mt-2">
                    <i class="uil uil-check-circle fs-4" style="color: #1ce1ac;margin-right: 15px"></i>
                    <h5 style="color: #303160;">Multumim pentru inrolare !</h5>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-2">
                    <div>Ținem la afacerea ta. De azi, beneficiezi în mod gratuit de funcționalitățile unui soft de gestiune. FreyaShop te va ajuta să gestionezi mai eficient activitatea din magazin.
                        Iată care sunt următorii pași:
                    </div>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-2">
                    1. <strong style="margin-left: 3px;"><a href="{{downloadUrl}}" class="link"> Click aici</a></strong><p style="margin-bottom:  0px;margin-left: 5px;"> pentru a descarca programul. Pentru autentificare vei folosi :</p>
                </div> 
                <div>
                    <ul>
                      <li><div>Codul de licenta Freya Shop POS <strong> {{frontOfficeApiKey}} </strong></div></li>
                      <li><div>Codul de licenta Freya Shop Back Office <strong> {{backOfficeApiKey}} </strong></div></li>
                    </ul>
                </div>

                <div>
                    2. Instalează cele două programe, urmând pașii menționați în acest document. Click <strong style="margin-left: 3px;"><a href="{{downloadTrainingUrl}}" class="link">aici</a></strong> pentru a descarca documentul.
                </div>
                <div class="mt-2">
                    3. Urmărește materialele video pentru a instala cele două module – <strong style="margin-left: 3px;"><a href="{{frontOfficeVideoUrl}}" class="link" target="_blank">Freya Shop POS</a></strong> , <strong style="margin-left: 3px;"><a href="{{backOfficeVideoUrl}}" class="link" target="_blank">Freya Shop Back Office</a></strong>
                </div>
                <!-- <div class="d-flex justify-content-start align-items-center mt-2">
                    <strong><a href="{{downloadUrl}}" class="link">Click aici pentru a incepe descarcarea.</a></strong>
                </div>  -->
                <div class="d-flex justify-content-start align-items-center mt-2">
                    <div>Dacă ai nevoie de asistență pentru instalarea programului contactează-ne la  numărul de telefon 021 539 7878 și vei primi o ofertă de preț pentru acest serviciu.</div>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-2">
                    <div><strong>Succes!</strong></div>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-2">
                    <div><strong>Echipa FreyaPos</strong></div>
                </div>
            </div>
            <div class="card-footer">
                <button class="btn btn-primary mt-2 custom-secondary-button w-100" id="btnSave" #btnSave (click)="btnFinish()">
                    <span style="margin-right: 7px;">Finalizare</span>
                </button>
            </div>
        </div>
    </div>
    <!-- <div style="position: relative;">
        <img src="assets/img/newlogo.svg" alt="Logo" style="position: absolute; bottom: 40px; right: 20px;" height="30"> />
    </div> -->
</div>